import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router'

import { URL_PAGE_DELIVERY_INFO, URL_PAGE_PAYMENT_INFO } from '@shared/contants'

import styles from './styles.module.scss'

export const DeliveryPaymentTabs = () => {
  const { t } = useTranslation('common')

  const tabs = [
    { label: t('payment'), to: URL_PAGE_PAYMENT_INFO },
    { label: t('delivery'), to: URL_PAGE_DELIVERY_INFO },
  ]

  return (
    <div className={styles.root}>
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) =>
            classNames(styles.root__tab, {
              [styles['root__tab--active']]: isActive,
            })
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </div>
  )
}
